<template>
  <div v-if="loaded" class="row">
  <!-- Réorganise ton formulaire ici -->
        <mh-input mhClass="col-6" label="Créancier" field="creancierID" :table="invoice"></mh-input>
    <mh-input mhClass="col-6" field="date" :table="invoice"></mh-input>

    <mh-input mhClass="col-3" field="type" :table="invoice"></mh-input>
    <mh-input mhClass="col-3" field="reference_societe" :table="invoice"></mh-input>
    <mh-input mhClass="col-6" field="reference_client" :table="invoice"></mh-input>

    <mh-input @change="computeTVAC" mhClass="col-3" field="prixHTVA" :table="invoice" append="€"></mh-input>
    <mh-input  mhClass="col-3" readonly field="tva" :table="invoice" append="%"></mh-input>
    <mh-input mhClass="col-3" readonly field="prixTVAC" :table="invoice" append="€"></mh-input>
    <mh-input mhClass="col-3" field="solde" :table="invoice" append="€"></mh-input>
    
    <mh-input mhClass="col-9" label="Vendeur" field="vendeurID" :table="invoice"></mh-input>
    <mh-input mhClass="col-3" readonly field="vendeur_commission" :table="invoice" append="%"></mh-input>
    <mh-input mhClass="col-12" field="note" :table="invoice"></mh-input>
    <b-col class="text-right mt-3">
      <b-button @click="$emit('close')">Annuler</b-button>
      <b-button @click="save" class="ml-3">Enregistrer</b-button>
    </b-col>
  </div>
</template>

<script>
import invoices from "@/services/invoices";
import MhInput from "@/components/MhInput.vue";
export default {
  name: "Invoice",
  components: {
    MhInput,
  },
  props: {
    invoice_id: [Number, String],
  },
  data() {
    return {
      invoice: {},
      loaded: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    computeTVAC() {
      this.invoice.prixTVAC.value = (Number(this.invoice.prixHTVA.value) * (1 + Number(this.invoice.tva.value / 100))).toFixed(2);
    },
    load() {
      invoices
        .invoice({
          invoice_id: this.invoice_id,
        })
        .then((response) => {
          this.invoice = response.data;
          this.loaded = true;
        });
    },
    
    save() {
      invoices.update_invoice({
        invoice_id: this.invoice_id,
        invoice: this.invoice
      }).then(response => {
        if (response.data.success) {
          this.$bvToast.toast("invoice mise à jour", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
          for (let el in this.invoice) {
            if (this.invoice[el]) {
              this.invoice[el].error = false;
            }
          }
          this.$emit('change');
          this.$emit('close');
        } else if (response.data.fail) {
          for (let el in this.invoice) {
            if (this.invoice[el]) {
              this.invoice[el].error = false;
            }
          }
          response.data.fail.forEach((element) => {
            this.invoice[element.field].error = element.errors.join(" ; ");
          });
        } else if (response.data.error) {
          this.$bvToast.toast("Erreur : " + response.data.error, {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 2000,
            solid: false,
          });
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
</style>